// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"Backdrop_Backdrop__8ha-G"};